import $ from "jquery";
import 'select2';
import jobStoreFinderHelper from './lsag.jobStoreFinderHelper'

const jobFinder = {
    cities: Array(),
    init() {
        $.ajax({
            url: ACC.config.dataFileJobfinder + '?v=' + Date.now(),
            type: 'GET',
            dataType: 'text',
            contentType: 'text/xml',
            async: true,
            success: function (response) {
                jobFinder.fillElements(response);
                jobStoreFinderHelper.sortSelectOptions('#country-filter', true);
                $('#country-filter').select2({
                    width: '100%',
                    minimumResultsForSearch: Infinity
                });
                $('#city-filter').select2({
                    width: '100%',
                    minimumResultsForSearch: Infinity
                });
                jobFinder.bindCityFilter();
                jobFinder.bindCountryFilter();
                jobFinder.bindToggleJob();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // log the error to the console
                console.log('The following error occurred: ' + textStatus, errorThrown);
            }
        });
    },
    fillElements(response) {

        var brand = '';
        if (ACC.config.mandant === 'HUMANIC') {
            brand = 'HUMANIC';
        } else if (ACC.config.mandant === 'S4Y') {
            brand = 'SHOE 4 YOU';
        }

        $(response).find('[nodeId]').each((i, element) => {

            var tr = document.createElement('tr');
            tr.style.display = 'none';
            document.getElementById('jobfinder-table').appendChild(tr);

            var countryId = '';
            var countryText = '';
            var cityText = '';

            $(element).find('[name]').each((j, element) => {
                var name = $(element).attr('name');
                var value = $(element).html();
                // IE11 fix
                if (value === undefined) {
                    value = element.textContent;
                }
                value = value.replace(']]>', '');
                if (name === 'defaultview_brand_de' && value !== brand) {
                    return false;
                }

                if (name === 'country') {
                    countryId = value;
                }

                if (name === 'defaultview_country_de') {
                    countryText = value;
                }

                if (name === 'sys_view_city') {
                    cityText = value;
                    var tdCity = document.createElement('td');
                    tdCity.innerHTML = value;
                    tdCity.classList.add('city');
                    tr.appendChild(tdCity);
                }

                if (name === 'title') {
                    var tdJob = document.createElement('td');
                    tdJob.innerHTML = value;
                    tr.appendChild(tdJob);
                }

                if (name === 'job_description') {
                    var trDescription = document.createElement('tr');
                    trDescription.id = 'row_' + i;
                    trDescription.style.display = 'none';
                    document.getElementById('jobfinder-table').appendChild(trDescription);

                    var tdDescription = document.createElement('td');
                    tdDescription.colSpan = '3';
                    tdDescription.innerHTML = jobStoreFinderHelper.decodeXml(value);
                    trDescription.appendChild(tdDescription);
                }

                if (countryText !== '' && cityText !== '') {
                    // country options
                    var option = document.createElement('option');
                    option.text = countryText;
                    option.value = countryId;
                    if (document.getElementById('country-filter').innerHTML.indexOf('>' + countryText + '<') < 0) {
                        document.getElementById('country-filter').appendChild(option);
                    }

                    if (this.cities.filter(function (e) {
                        return e.cityText === cityText;
                    }).length <= 0) {
                        var city = new Object();
                        city.countryId = countryId;
                        city.cityText = cityText;
                        this.cities.push(city);
                    }
                }
            });

            var tdIcon = document.createElement('td');
            tdIcon.innerHTML = '<a class="js-toggle-job" data-rowid="row_' + i + '" href="#"><svg class="icon icon-arrow-right align-middle"><use xlink:href="#icon-arrow-right"></use></svg></a>';
            tr.appendChild(tdIcon);
        });
        jobStoreFinderHelper.sortCities(this.cities);
    },
    bindCountryFilter() {
        $('#country-filter').change(function () {
            $('#jobfinder-table').find('tr').hide();
            var countryId = $(this).val();

            $('#city-filter').find('option').each((index, element) => {
                if (index > 0) {
                    $(element).remove();
                }
            });
            $('#city-filter').trigger('change');
            jobFinder.cities.forEach(function (item) {
                if (item.countryId === countryId) {
                    var option = new Option(item.cityText, item.cityText, false, false);
                    $('#city-filter').append(option);
                }
            });
            $('#city-filter').trigger('change');
        });
    },
    bindCityFilter() {
        $('#city-filter').change(function () {
            jobFinder.filterTable();
        });
    },
    bindToggleJob() {
        $('.js-toggle-job').click(function (e) {
            e.preventDefault();
            var $row = $('#' + $(this).attr('data-rowid'));
            if ($(this).closest('tr').hasClass('active')) {
                $row.hide();
                $(this).closest('tr').removeClass('active');
            } else {
                $row.show();
                $(this).closest('tr').addClass('active');
            }

        });
    },
    filterTable() {
        var city = $('#city-filter').val();
        $('#jobfinder-table').find('tr').each((index, element) => {
            var $city = $(element).find('.city');
            if (city === $city.html()) {
                $(element).show();
            } else {
                $(element).hide();
            }
        });
    }
};

// DOM ready
$(() => {
    if ($('.jobfinder-top').length) {
        jobFinder.init();
    }
});

export default jobFinder;
